export const SESSION_ID_HEADER = 'X-Session-ID';
export const THRESHOLD_PROP = 'inactivityThreshold';
export const INACTIVITY_START_PROP = 'inactivityStartedAt';
export const INACTIVITY_THRESHOLD = 240000; // 4 min
export const PROMPT_TIMEOUT = 60000; // 1 min
export const HEART_BEAT = 5000; // 5 seconds
export const MAX_INACTIVITY_PERIOD = INACTIVITY_THRESHOLD + PROMPT_TIMEOUT;

export const THRESHOLD = {
  LOW: 'low',
  MEDIUM: 'medium',
  HIGH: 'high',
};
